import React, { Component } from "react";
import { Label, Input, ModalFooter, Button } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { Endpoint } from "./../../../Utils/Endpoint";
import firetoast from "./../../../Utils/Firetoast";
class AdminEditTimeField extends Component {
  state = {
    data: {
      is_active: 1,
    },
  };
  componentDidMount = () => {
    var field = this.props.field;
    var data = {
      field_id: field.id,
      default_value: field.default_value,
      field_name: field.field_name,
      extra_info: field.extra_info,
    };
    this.setState({
      data,

      field_name: field.field_name,
      default_value: field.default_value,
    });
  };
  render() {
    var { field } = this.props && this.props;

    return (
      <>
        <div class="mb-3 row">
          <label class="col-sm-3 col-form-label">
            {" "}
            Label Name <span className="text-danger">*</span>
          </label>
          <div class="col-sm-9">
            <Input
              class="form-control"
              type="text"
              defaultValue={field.field_name}
              onChange={this.handleChange}
              name="field_name"
            />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-3 col-form-label">Image</label>
          <div class="col-sm-9">
            <Input
              class="form-control"
              type="file"
              name="image"
              onChange={this.handleImageChange}
            />
          </div>
        </div>

        <ModalFooter>
          <Button color="primary" className="btn-sm" onClick={this.Save}>
            Save
          </Button>{" "}
          {/* <Button
                    color="secondary"
                    onClick={() => this.toggleCustomField(!customField)}
                  >
                    Cancel
                  </Button> */}
        </ModalFooter>
      </>
    );
  }
  handleImageChange = (e) => {
    var data = { ...this.state.data };
    if (e.target.files[0]) {
      data[e.target.name] = e.target.files[0];
      this.setState({ data });
    }
  };
  handleChange = ({ currentTarget: input }) => {
    var data = { ...this.state.data };
    if (
      input.value === "" ||
      input.value == null ||
      input.value === undefined
    ) {
      delete [input.name];
      this.setState({ data });
    } else {
      data[input.name] = input.value;
      this.setState({ data });
    }
  };
  handleExtraInfo = async ({ currentTarget: input }) => {
    var data = { ...this.state.data };
    if (
      input.value === "" ||
      input.value == null ||
      input.value === undefined
    ) {
      delete data[input.name];
      this.setState({ data });
    } else {
      var length = { length: parseInt(input.value) };
      data[input.name] = length;
      this.setState({ data });
    }
  };
  Save = async () => {
    var data = this.state.data;
    //console.log(data);
    data["name"] = data["field_name"];
    if (!data["image"]) {
      return firetoast(
        "Please provide field image",
        "error",
        3000,
        "top-center"
      );
    }
    data["options"] = JSON.stringify(data["extra_info"]);
    data["field_id"] = this.props.field.id;
    delete data["extra_info"];
    delete data["field_name"];
    delete data["default_value"];
    delete data["is_active"];
    var form = new FormData();
    for (var key in data) {
      form.append(key, data[key]);
    }
    try {
      var response = await axios.post(
        Endpoint + `/admin/universal-fields/update`,
        form,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.data.success === 200) {
        toast.info("Field Updated");
        this.props.toggleEdit();
        this.props.refreshSection();
      }
    } catch (e) {
      var error = e.response.data.message;
      if (Array.isArray(error)) {
        // toast.error(e.response.data.message[0]);
        firetoast(error[0], "error", 5000, "top-right");
      } else {
        firetoast(error, "error", 5000, "top-right");
        // toast.error(e.response.data.message);
      }
    }
  };
  setActiveField = () => {
    var data = { ...this.state.data };
    if (this.state.activeField) {
      data["is_active"] = 0;
      this.setState({ data, activeField: false });
    } else {
      data["is_active"] = 1;
      this.setState({ data, activeField: true });
    }
  };
  setIsMandatory = () => {
    var data = { ...this.state.data };
    if (this.state.is_mandatory) {
      data["is_mandatory"] = 0;
      this.setState({ data, is_mandatory: false });
    } else {
      data["is_mandatory"] = 1;
      this.setState({ data, is_mandatory: true });
    }
  };
  setIsQuickCreate = () => {
    var data = { ...this.state.data };
    if (this.state.is_quick_create) {
      data["is_quick_create"] = 0;
      this.setState({ data, is_quick_create: false });
    } else {
      data["is_quick_create"] = 1;
      this.setState({ data, is_quick_create: true });
    }
  };
  setIsKeyField = () => {
    var data = { ...this.state.data };
    if (this.state.is_key_field) {
      data["is_key_field"] = 0;
      this.setState({ data, is_key_field: false });
    } else {
      data["is_key_field"] = 1;
      this.setState({ data, is_key_field: true });
    }
  };
  setIsTableView = () => {
    var data = { ...this.state.data };
    if (this.state.is_table_view) {
      data["is_table_view"] = 0;
      this.setState({ data, is_table_view: false });
    } else {
      data["is_table_view"] = 1;
      this.setState({ data, is_table_view: true });
    }
  };
}

export default AdminEditTimeField;
